import { atom } from "jotai";
import { createAsyncStore } from "common/axios/asyncModel";
import { UserRepository } from "repository/userRepository";

// ==================== Async Stores ====================

// 로그인
const login = createAsyncStore();
const socialLogin = createAsyncStore();

// 회원가입
const signup = createAsyncStore();
const signupPolicy = createAsyncStore();        // 가입 화면 진입 시 정책 적용 여부
const signupPolicyCheck = createAsyncStore();   // 생년월일 입력 후 판정
const checkDuplicateEmail = createAsyncStore();
const checkDuplicateCtn = createAsyncStore();
const termsList = createAsyncStore();
const termsItem = createAsyncStore();
const sendVerifyCode = createAsyncStore();
const checkVerifyCode = createAsyncStore();

// 다날 본인인증 (포트원)
const portOneSend = createAsyncStore();
const portOneConfirm = createAsyncStore();

// 회원탈퇴
const withdrawTerms = createAsyncStore();
const withdraw = createAsyncStore();

// 아이디·비밀번호 찾기
const findAccount = createAsyncStore();
const resetPassword = createAsyncStore();

// TODO. 아이디/비밀번호 찾기


// ==================== UI State Atoms ====================

// 회원가입 단계 (1-5)
export const signupStepAtom = atom<number>(1);

// 회원가입 중단 확인 팝업
export const isAbortSignupAtom = atom<boolean>(false);

// 본인인증 완료 여부
export const isVerifiedAtom = atom<boolean>(false);

// 약관 동의 완료 여부
export const isTermsAgreedAtom = atom<boolean>(false);

// ==================== Actions ====================

// 로그인
const onLogin = (params: any) => {
    login.onGetAll(() => UserRepository.onPostLogin(params));
}
const onSocialLogin = (params: any) => {
    socialLogin.onGetAll(() => UserRepository.onPostSocialLogin(params));
}

// 회원가입
const onSignup = (params: any) => {
    signup.onGetAll(() => UserRepository.onPostSignup(params));
}
const onGetSignupPolicy = (params: { serviceId: string; countryCd?: string }) => {
    signupPolicy.onGetAll(() => UserRepository.onPostSignupPolicy(params));
}
const onCheckSignupPolicy = (params: { serviceId: string; birth: string; countryCd?: string; ctnCountryCd?: string }) => {
    signupPolicyCheck.onGetAll(() => UserRepository.onPostSignupPolicy(params));
}
const onCheckDuplicateEmail = (userId: string, serviceId: string) => {
    checkDuplicateEmail.onGetAll(() => UserRepository.onGetCheckDuplicateEmail(userId, serviceId));
}
const onCheckDuplicateCtn = (params: any) => {
    checkDuplicateCtn.onGetAll(() => UserRepository.onPostCheckDuplicateCtn(params));
}
const onGetTermConsent = (locale: string, serviceId: string, searchTag?: string) => {
    termsList.onGetAll(() => UserRepository.onGetTermsList(locale, serviceId, searchTag));
}
const onGetTermsDetailConsent = (termsId: string) => {
    termsItem.onGetAll(() => UserRepository.onGetTermsDetail(termsId));
}
const onSendVerifyCode = (params: any) => {
    sendVerifyCode.onGetAll(() => UserRepository.onPostSendVerifyCode(params));
}
const onCheckVerifyCode = (params: any) => {
    checkVerifyCode.onGetAll(() => UserRepository.onPostCheckVerifyCode(params));
}
const onPortOneSend = (params: any) => {
    portOneSend.onGetAll(() => UserRepository.onPostPortOneSend(params));
}
const onPortOneConfirm = (params: any) => {
    portOneConfirm.onGetAll(() => UserRepository.onPostPortOneConfirm(params));
}

// 회원탈퇴 약관 목록 (searchTag=withdraw — N개 약관 지원)
const onGetWithdrawTerms = (serviceId: string, locale: string) => {
    withdrawTerms.onGetAll(() => UserRepository.onGetTermsList(locale, serviceId, "withdraw"));
}
// 회원탈퇴
const onWithdraw = (params?: { reason?: string }) => {
    withdraw.onGetAll(() => UserRepository.onDeleteWithdraw(params));
}

// 아이디·비밀번호 찾기 — 본인인증 결과로 가입 계정 조회
const onFindAccount = (params: any) => {
    findAccount.onGetAll(() => UserRepository.onPostFindAccount(params));
}
// 비밀번호 재설정
const onResetPassword = (params: any) => {
    resetPassword.onGetAll(() => UserRepository.onPostResetPassword(params));
}


// ==================== Export ====================

export const userStore = {
    // Async Stores
    login,
    socialLogin,
    signup,
    signupPolicy,
    signupPolicyCheck,
    checkDuplicateEmail,
    checkDuplicateCtn,
    termsList,
    termsItem,
    sendVerifyCode,
    checkVerifyCode,
    portOneSend,
    portOneConfirm,
    withdrawTerms,
    withdraw,
    findAccount,
    resetPassword,

    // Actions
    onLogin,
    onSocialLogin,
    onSignup,
    onGetSignupPolicy,
    onCheckSignupPolicy,
    onCheckDuplicateEmail,
    onCheckDuplicateCtn,
    onGetTermConsent,
    onGetTermsDetailConsent,
    onSendVerifyCode,
    onCheckVerifyCode,
    onPortOneSend,
    onPortOneConfirm,
    onGetWithdrawTerms,
    onWithdraw,
    onFindAccount,
    onResetPassword,
}